import { fontawesomeIconConfig, IconConfig } from '@spartacus/storefront'

const ebFontawesomeIconConfig: IconConfig = fontawesomeIconConfig

ebFontawesomeIconConfig.icon.symbols.GLOBE = 'fas fa-globe'
ebFontawesomeIconConfig.icon.symbols.FILE = 'fas fa-file-alt'
ebFontawesomeIconConfig.icon.symbols.PEN = 'fas fa-pen'
ebFontawesomeIconConfig.icon.resources = []

export default ebFontawesomeIconConfig
